
import WX from 'weixin-js-sdk'
import { getWechatShare } from '@/api/api_home'
import { version } from './util.js'

export const WechatShare = async function (shareData, localUrl) {
  // 非微信环境不启动
  if(!version().weixin) return;
  try {
    let url = localUrl ? localUrl : window.location.href.split('#')[0]
    console.log(url)
    // 初始化函数
    let result = await getWechatShare({
      url: encodeURIComponent(`${url}`)
    }).catch(err => err);
    if (result && result.code === '000000') {
      WX.config({
        debug: false,
        appId: result.data.appId, // 必填，公众号的唯一标识
        timestamp: result.data.timestamp, // 必填，生成签名的时间戳
        nonceStr: result.data.nonceStr, // 必填，生成签名的随机串
        signature: result.data.signature, // 必填，签名，见附录1
        jsApiList: [
          'updateAppMessageShareData',
          'updateTimelineShareData'
          /* 'onMenuShareTimeline',
          'onMenuShareAppMessage' */
        ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      })
      WX.error((err) => {
        console.log('分享初始化err')
        console.log(err)
      });
      WX.ready(function() {
        WX.updateAppMessageShareData({
          ...shareData,
          success: function () {
            console.log('初始化分享到微信成功');
          }
        })
        //分享到朋友圈 qq空间
        WX.updateTimelineShareData({
          ...shareData,
          success: function () {
            console.log('初始化分享到朋友圈成功');
          }
        })
        /* WX.onMenuShareTimeline({
          ...shareData,
          success: function () {
            console.log('用户点击了分享后执行的回调函数')
          }
        })
        WX.onMenuShareAppMessage({
          ...shareData,
          success: function () {
            console.log('用户点击了分享后执行的回调函数')
          }
        }) */
      })
    }
  } catch (error) {
    console.log(error);
  }
}

export default {
  install(Vue) {
      Vue.prototype.WechatShare = WechatShare;
  }
}
